import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from "react-transition-group";
import "./Modal.css";

class Modal extends Component {
  handleCloseModal = modalType => {
    if (modalType === "action") {
      this.props.openCloseActionModal(false, -1);
    } else if (modalType === "schedule") {
      this.props.openCloseScheduleModal(false);
    } else if (modalType === "free") {
      this.props.openCloseFreeModal(false);
    } else if (modalType === "sign-in") {
      this.props.openCloseSignInModal(false);
    }
  };

  getModalType = () => {
    if (this.props.showActionModal) {
      return "action";
    } else if (this.props.showScheduleModal) {
      return "schedule";
    } else if (this.props.showFreeModal) {
      return "free";
    } else if (this.props.showSignInModal) {
      return "sign-in";
    } else {
      return null;
    }
  };

  render() {
    const modalType = this.getModalType();
    let minWidth = false;
    if (!(modalType === "sign-in")) {
      minWidth = true;
    }

    const modalContent = (
      <div className={`modal-container min-width-${minWidth}`}>
        <div className={`modal ${modalType}-modal`}>
          <div className="modal-close-container">
            <div
              className="close"
              onClick={() => this.handleCloseModal(modalType)}
            >
              X
            </div>
          </div>
          {this.props.children}
        </div>
        <div
          className="overlay"
          onClick={() => this.handleCloseModal(modalType)}
        />
      </div>
    );

    return (
      <CSSTransitionGroup
        transitionName="modal-transition"
        transitionAppearTimeout={1000}
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}
      >
        {this.getModalType() ? modalContent : null}
      </CSSTransitionGroup>
    );
  }
}

Modal.propTypes = {
  openCloseActionModal: PropTypes.func,
  openCloseScheduleModal: PropTypes.func,
  openCloseFreeModal: PropTypes.func,
  openCloseSignInModal: PropTypes.func,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js